wbApp.controller('RentItemsCtrl', ['$scope', '$modal', '$translate', '$timeout', '$q', 'rentItemSvc', 'classroomSvc', 'rentCategorySvc', 'itemTypeSvc',
function ($scope, $modal, $translate, $timeout, $q, rentItemSvc, classroomSvc, rentCategorySvc, itemTypeSvc) {

    function refreshData(reselect)
    {
        return $q(function (resolve, reject) {
            var selectedRowKeys = null;
            if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                selectedRowKeys = $scope.gridSettings.gridInstance.getSelectedRowKeys();
            }

            var all = rentItemSvc.getAll(true);
            all.$promise.then(function (data) {
                $scope.rentItems = data;

                if (!!selectedRowKeys && !!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                    $timeout(function () {
                        $scope.gridSettings.gridInstance.selectRows(selectedRowKeys, false).then(function (rows) {
                            if (!rows || !rows.length) {
                                setSelectedRentItem(null);
                            }
                        })
                    }, 100);
                }
                else {
                    setSelectedRentItem(null);
                }

                resolve();

            }, function (error) {
                $scope.rentItems = [];
                setSelectedRentItem(null);

                reject();
            });
        });
    }

    refreshData();

    $scope.$on('refreshData', function (e, data) {
        refreshData(true);
    });

    var classroomDataSource = new DevExpress.data.CustomStore({
        load: function (loadOptions) {
            return classroomSvc.getAllAsync().$promise;
        },
        byKey: function (e) {
            return classroomSvc.getAsync(e);
        },
        loadMode: 'processed'
    });

    var rentCategoryDataSource = new DevExpress.data.CustomStore({
        load: function (loadOptions) {
            return rentCategorySvc.getAll().$promise;
        },
        byKey: function (e) {
            return rentCategorySvc.getById(e);
        },
        loadMode: 'processed'
    });

    var itemTypeDataSource = new DevExpress.data.CustomStore({
        load: function (loadOptions) {
            return itemTypeSvc.getAll().$promise;
        },
        byKey: function (e) {
            return itemTypeSvc.getById(e);
        },
        loadMode: 'processed'
    });

    $scope.gridSettings = {
        name: 'rentItems',
        keyExpr: 'id',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
            {
                dataField: 'rentCategoryId',
                caption: $translate.instant('TXT_MENU_RENT_CATEGORY'),
                dataType: 'string',
                width: '150px',
                visible: true,
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: rentCategoryDataSource,
                        pageSize: 20,
                        paginate: true
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
            },
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '160px', sortOrder: 'asc' },
            {
                dataField: 'itemTypeId',
                caption: $translate.instant('TXT_MENU_ITEM_TYPE'),
                dataType: 'string',
                width: '150px',
                visible: true,
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: itemTypeDataSource,
                        pageSize: 20,
                        paginate: true
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
            },
            { dataField: 'externalId', caption: $translate.instant('TXT_EXTERNAL_ID'), dataType: 'string', width: '160px' },
            { dataField: 'shortDescription', caption: $translate.instant('TXT_LBL_SHORT_DESCRIPTION'), dataType: 'string' },
            {
                dataField: 'placeId',
                caption: $translate.instant('TXT_PLACE'),
                dataType: 'string',
                width: '150px',
                visible: true,
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: classroomDataSource,
                        pageSize: 20,
                        paginate: true
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
            },
            {
                dataField: 'itemCondition',
                caption: $translate.instant('TXT_MENU_ITEM_CONDITION'),
                dataType: 'string',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_ITEM_CONDITION_TYPE_READY_FOR_RENTING') },
                                { id: 1, name: $translate.instant('TXT_ITEM_CONDITION_TYPE_BROKEN') },
                                { id: 2, name: $translate.instant('TXT_ITEM_CONDITION_TYPE_MAINTENANCE') },
                                { id: 3, name: $translate.instant('TXT_ITEM_CONDITION_TYPE_DECOMMISSIONED') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                width: '150px'
            },
        ]
    }


    $scope.onRowSelected = function (data) {
        setSelectedRentItem(data);
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = rentItemSvc.createNew();
            detailDialogPromise.$scope.onRentItemSave = function (model) {
                refreshData().then(function() {
                    if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                        $timeout(function () {
                            $scope.gridSettings.gridInstance.selectRows([model.id], false).then(function (rows) {
                                if (!rows || !rows.length) {
                                    setSelectedRentItem(null);
                                }
                            });
                        }, 100);
                    }
                });
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onRentItemSave = function () {
                refreshData(true);
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowCopy = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.model.id = null;
            detailDialogPromise.$scope.model.isNew = true,
            detailDialogPromise.$scope.onRentItemSave = function (model) {
                refreshData().then(function () {
                    if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                        $timeout(function () {
                            $scope.gridSettings.gridInstance.selectRows([model.id], false).then(function (rows) {
                                if (!rows || !rows.length) {
                                    setSelectedRentItem(null);
                                }
                            });
                        }, 100);
                    }
                });
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        rentItemSvc.remove(data.id).$promise.then(function () {
            refreshData();
        });
    }

    function setSelectedRentItem(rentItem, refresh) {
        $scope.selectedRentItem = rentItem;
        $scope.$broadcast('rentItemSelectionChanged', $scope.selectedRentItem);
    }

    $scope.tabs = [
    {
        title: 'TXT_MENU_RENTS',
        template: "rents/rent-item/rent-item-detail-tabs/rents.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });


    var detailDialogPromise = $modal({
        templateUrl: 'rents/rent-item/rent-item-detail.html',
        show: false,
        scope: $scope.$new()
    });


}]);
